import { Autocomplete, Box, Container, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import Bottom from "./Bottom";
import { useEffect } from "react";
import api from "../utils/api_v2";
import LodingData from "../utils/LodingData";

import useComparisonHospitalStore from "../store/ComparisonHospitalStore";
import tab03 from "../assets/images/tab_04.png"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const ComparisonHospital = () => {

  const storeData: any = useComparisonHospitalStore();

  useEffect(() => {
    getHospitalList();

    return () => {
      storeData.clear();
    }
  }, [])

  // select box 병원 리스트
  function getHospitalList() {
    LodingData(() => api.post('customer/api/v1/CU_006_001', { cusId: localStorage.getItem('userCusID') })
      .then(res => {
        // console.log(res);
        storeData.setHospitalList(res.data);

        let tempObjList = [];
        let nameSet = new Set();
        for (let i = 0; i < res.data.length; i++) {
          let hosName = res.data[i].hosPkg.split('-')[0];
          let region = res.data[i].region;

          if (!nameSet.has(hosName)) {
            nameSet.add(hosName);
            tempObjList.push({ hosName, region });
          }
        }

        // 지역 기준으로 정렬
        tempObjList.sort((a, b) => {
          if (a.region < b.region) return -1;
          if (a.region > b.region) return 1;
          return 0;
        });

        tempObjList.unshift({ hosName: '선택' })
        storeData.setSelectHospitalList(tempObjList);

      })
      .catch(err => {
        console.log(err);
      }));
  }

  // 병원 선택 시
  function handlesearchParams(target: number, value: any) {
    if (value.hosName == '선택') value = { hosName: '선택' };
    else if (value == null) return;

    let tempPackageList = [];
    for (let i = 0; i < storeData.hospitalList.length; i++) {
      let name = storeData.hospitalList[i].hosPkg.split('-')[0];

      if (value.hosName == name) {
        tempPackageList.push({ pkgId: storeData.hospitalList[i].pkgId, name: storeData.hospitalList[i].hosPkg.split('-')[1] });
      }
    }
    tempPackageList.unshift({ name: '선택', pkgId: 'pkg' });

    if (target == 0) {
      storeData.setSearchPackage1({ pkgId: '', name: '' });
      storeData.setSearchHospitalObj1(value);

      storeData.setSelectPackageList1(tempPackageList);
    } else if (target == 1) {
      storeData.setSearchPackage2({ pkgId: '', name: '' });
      storeData.setSearchHospitalObj2(value);

      storeData.setSelectPackageList2(tempPackageList);
    } else if (target == 2) {
      storeData.setSearchPackage3({ pkgId: '', name: '' });
      storeData.setSearchHospitalObj3(value);

      storeData.setSelectPackageList3(tempPackageList);
    }
  }

  // 패키지 선택 시
  function handlesearchPackage(target: number, value: any) {
    // console.log(target, value);

    if (value.hosName == '선택') value = { name: '선택', pkgId: 'pkg' };
    else if (value == null) return;

    if (target == 0) {
      storeData.setSearchPackage1(value);
      getPackage(value.pkgId, target);
    } else if (target == 1) {
      storeData.setSearchPackage2(value);
      getPackage(value.pkgId, target);
    } else if (target == 2) {
      storeData.setSearchPackage3(value);
      getPackage(value.pkgId, target);
    }
  }

  // 선택한 패키지id 받아 패키지 가져오기
  function getPackage(id: any, target: number) {
    if (id == 'pkg' || id == '') {
      return;
    } else {
      LodingData(() => api.post('customer/api/v1/CU_006_002', { pkgId: id })
        .then(res => {
          // console.log(res);
          storeData.setInspectionView(true);

          addBaseInjectionData(res.data, target); // 기본검사
          setChoiceInjectionData(res.data, target); // 선택검사
          setAddInjectionTable(res.data, target); // 추가검사
        })
        .catch(err => {
          console.log(err);
        }));
    }
  }

  //패키지별 기본 검사항목 세팅
  function addBaseInjectionData(data: any, target: number) {
    let baseInjection = new Set();
    let select = new Set();

    for (let i = 0; i < data.length; i++) {
      if (data[i].ipClass == '기본') {
        for (let j = 0; j < data[i].inspection.length; j++) {
          baseInjection.add(data[i].inspection[j]);
        }
      } else if (data[i].ipClass.indexOf('선택') > -1) {
        select.add(data[i].ipClass);
      }
    }
    // storeData.setSelectIpClassList(select);
    storeData.setPkgList(target, baseInjection);
    resetTotalInspectionItems();
  }

  // 기본검사 교집합 배열
  function resetTotalInspectionItems() {
    let totalInspectionItems = new Set();

    for (let i = 0; i < storeData.pkgList.length; i++) {
      if (storeData.pkgList[i] != null) {
        storeData.pkgList[i].forEach((value: any) => totalInspectionItems.add(value));
      }
    }

    storeData.setTotalInspectionItems(totalInspectionItems);
  }

  // 선택검사 각 인덱스 할당
  function setChoiceInjectionData(data: any, target: number) {
    let select = new Set();
    let choiceInspectionItems = [];
    let idx = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].ipClass.indexOf('선택') > -1) {
        choiceInspectionItems[idx] = data[i];
        select.add(data[i].ipClass);
        idx++;
        // storeData.setSelectInjectionList(target, data[i]);
        // storeData.setIpClassList(target, data[i].ipClass);
      }
    }
    storeData.setIpClassList(target, select);
    storeData.setSelectInjectionList(target, choiceInspectionItems);
    totalIpClassList();
  }

  // 선택검사 ipClass 교집합
  function totalIpClassList() {
    let totalIpClassList = new Set();

    for (let i = 0; i < storeData.ipClassList.length; i++) {
      if (storeData.ipClassList[i] != null) {
        storeData.ipClassList[i].forEach((value: any) => totalIpClassList.add(value));
      }
    }
    storeData.setSelectIpClassList(totalIpClassList);
  }

  // 추가 검사
  function setAddInjectionTable(data: any, target: number) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].ipClass == '추가') {
        storeData.setAddInjectionList(target, data[i].inspection);
      }
    }
  }

  function replaceCommas(text: any) {
    return text.replace(/,(?![^()]*\))/g, '\n');
  }


  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
              이용안내
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              병원별 검진 항목 비교
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Container className="White_box" sx={{ width: '83%', mr: 'auto', ml: 'auto' }}>
        <Grid container>
          <Grid container className='wb_container'>
            <TableContainer>
              <Table className="Cl_table">
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ width: 300, fontWeight: 'bold', background: '#f9f9f9' }}>병원</TableCell>
                    <TableCell>
                      <Autocomplete
                        openOnFocus
                        className='wb_select'
                        value={storeData.searchHospitalObj1.hosName == '' ? { hosName: '선택' } : storeData.searchHospitalObj1}
                        options={storeData.selectHospitalList}
                        groupBy={(option) => option.region}
                        getOptionLabel={(option) => option.hosName || ''}
                        isOptionEqualToValue={(option, value) => option.region === value.region && option.hosName === value.hosName}
                        onChange={(e, value) => handlesearchParams(0, value)}
                        sx={{ background: '#fff', width: '100%', '& input': { padding: '0px 5px !important', background: '#fff', height: 25, } }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        openOnFocus
                        className='wb_select'
                        value={storeData.searchHospitalObj2.hosName == '' ? { hosName: '선택' } : storeData.searchHospitalObj2}
                        options={storeData.selectHospitalList}
                        groupBy={(option) => option.region}
                        getOptionLabel={(option) => option.hosName || ''}
                        isOptionEqualToValue={(option, value) => option.region === value.region && option.hosName === value.hosName}
                        onChange={(e, value) => handlesearchParams(1, value)}
                        sx={{ background: '#fff', width: '100%', '& input': { padding: '0px 5px !important', background: '#fff', height: 25, } }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        openOnFocus
                        className='wb_select'
                        value={storeData.searchHospitalObj3.hosName == '' ? { hosName: '선택' } : storeData.searchHospitalObj3}
                        options={storeData.selectHospitalList}
                        groupBy={(option) => option.region}
                        getOptionLabel={(option) => option.hosName || ''}
                        isOptionEqualToValue={(option, value) => option.region === value.region && option.hosName === value.hosName}
                        onChange={(e, value) => handlesearchParams(2, value)}
                        sx={{ background: '#fff', width: '100%', '& input': { padding: '0px 5px !important', background: '#fff', height: 25, } }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ width: 300, fontWeight: 'bold', background: '#f9f9f9' }}>패키지</TableCell>
                    <TableCell>
                      <Autocomplete
                        openOnFocus
                        className='wb_select'
                        value={storeData.searchPackage1.name == '' ? { name: '선택', pkgId: 'pkg' } : storeData.searchPackage1}
                        options={storeData.selectPackageList1}
                        getOptionLabel={(option) => option.name || ''}
                        isOptionEqualToValue={(option, value) => option.name === value.name && option.pkgId === value.pkgId}
                        onChange={(e, value) => handlesearchPackage(0, value)}
                        sx={{ background: '#fff', width: '100%', '& input': { padding: '0px 5px !important', background: '#fff', height: 25, } }}
                        renderInput={(params) => <TextField {...params} />}
                        renderOption={(props, option) => (
                          <li {...props} key={option.pkgId}>{option.name}</li>
                        )}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        openOnFocus
                        className='wb_select'
                        value={storeData.searchPackage2.name == '' ? { name: '선택', pkgId: 'pkg' } : storeData.searchPackage2}
                        options={storeData.selectPackageList2}
                        getOptionLabel={(option) => option.name || ''}
                        isOptionEqualToValue={(option, value) => option.name === value.name && option.pkgId === value.pkgId}
                        onChange={(e, value) => handlesearchPackage(1, value)}
                        sx={{ background: '#fff', width: '100%', '& input': { padding: '0px 5px !important', background: '#fff', height: 25, } }}
                        renderInput={(params) => <TextField {...params} />}
                        renderOption={(props, option) => (
                          <li {...props} key={option.pkgId}>{option.name}</li>
                        )}
                      />
                    </TableCell>
                    <TableCell>
                      <Autocomplete
                        openOnFocus
                        className='wb_select'
                        value={storeData.searchPackage3.name == '' ? { name: '선택', pkgId: 'pkg' } : storeData.searchPackage3}
                        options={storeData.selectPackageList3}
                        getOptionLabel={(option) => option.name || ''}
                        isOptionEqualToValue={(option, value) => option.name === value.name && option.pkgId === value.pkgId}
                        onChange={(e, value) => handlesearchPackage(2, value)}
                        sx={{ background: '#fff', width: '100%', '& input': { padding: '0px 5px !important', background: '#fff', height: 25, } }}
                        renderInput={(params) => <TextField {...params} />}
                        renderOption={(props, option) => (
                          <li {...props} key={option.pkgId}>{option.name}</li>
                        )}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>

      {
        storeData.inspectionView
          ? <Box className="White_box" sx={{ width: '80%', mr: 'auto', ml: 'auto' }}>
            <Typography sx={{ fontWeight: 'bold', mb: 2 }}>기본검사</Typography>
            <TableContainer sx={{ height: '300px!important' }}>
              <Table stickyHeader aria-label="sticky table" className='chatbot_table' size='small' >
                <TableBody>
                  {
                    storeData.totalInspectionItems && Array.from(storeData.totalInspectionItems).map((item: any, idx: any) => {
                      let ox = [];
                      ox[0] = '';
                      ox[1] = '';
                      ox[2] = '';

                      for (let i = 0; i < storeData.pkgList.length; i++) {
                        if (storeData.pkgList[i] != null) {
                          ox[i] = (storeData.pkgList[i].has(item)) ? 'O' : 'X';
                        }
                      }

                      return (
                        <TableRow key={idx} sx={{ '& td': { borderRight: '1px solid #ccc' } }}>
                          <TableCell width={250} sx={{ background: '#f9f9f9!important', textAlign: 'left!important' }}>{item}</TableCell>
                          <TableCell width={285} sx={{ color: ox[0] == 'O' ? '#0095ff' : '#cb0000!important' }}>{ox[0]}</TableCell>
                          <TableCell width={285} sx={{ color: ox[1] == 'O' ? '#0095ff' : '#cb0000!important' }}>{ox[1]}</TableCell>
                          <TableCell sx={{ color: ox[2] == 'O' ? '#0095ff' : '#cb0000!important' }}>{ox[2]}</TableCell>
                        </TableRow>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>

            <Typography sx={{ fontWeight: 'bold', mb: 2, mt: 10 }}>선택검사</Typography>
            <TableContainer>
              <Table size="small" className="Cl_table" sx={{'& td': {cursor:'default'}}}>
                <TableBody>
                  {
                    storeData.selectIpClassList && Array.from(storeData.selectIpClassList).map((item: any, idx: any) => {
                      return (
                        <TableRow key={item} sx={{ '& td': { borderRight: '1px solid #ccc' } }}>
                          <TableCell sx={{width:'320px', background: '#f9f9f9!important', fontSize: 16 }}>{item}</TableCell>
                          {
                            [0, 1, 2].map((v: any, j: any) => {
                              if (storeData.selectInjectionList[v] != null && storeData.selectInjectionList[v][idx] != null) {
                                return (
                                  <TableCell width={300} key={j} sx={{ lineHeight: '1.6!important', whiteSpace: 'pre-wrap', textAlign: 'left!important', p: '30px 30px!important', verticalAlign: 'top' }}>
                                    {
                                      <Typography sx={{ color: '#0095ff', mb: 2, fontWeight: 'bold' }}>선택개수 : {storeData.selectInjectionList[v][idx].choiceLimit}</Typography>
                                    }
                                    {
                                      storeData.selectInjectionList[v][idx].inspection.map((inspection: any) => {
                                        return (
                                          '- ' + inspection + '\n'
                                        )
                                      })
                                    }
                                  </TableCell>
                                )
                              } else {
                                return (
                                  <TableCell key={j} width={300}></TableCell>
                                )
                              }
                            })
                          }
                        </TableRow>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>

            <Typography sx={{ fontWeight: 'bold', mb: 2, mt: 10 }}>추가검사</Typography>
            <TableContainer>
              <Table size="small" className="Cl_table" sx={{'& td': {cursor:'default'}}}>
                <TableBody>
                  <TableRow sx={{ '& td': { borderRight: '1px solid #ccc' } }}>
                    <TableCell sx={{ background: '#f9f9f9!important', fontSize: 16, width: '285px' }}>추가검사</TableCell>
                    {
                      storeData.addInjectionList[0] == null
                        ? <TableCell width={300}></TableCell>
                        : <TableCell width={280} sx={{ lineHeight: '1.6!important', whiteSpace: 'pre-wrap', textAlign: 'left!important', p: '30px 30px!important', verticalAlign: 'top' }}>
                          {
                            storeData.addInjectionList[0].map((item: any) => {
                              return (
                                '- ' + replaceCommas(item) + '\n'
                              )
                            })
                          }
                        </TableCell>
                    }
                    {
                      storeData.addInjectionList[1] == null
                        ? <TableCell width={300}></TableCell>
                        : <TableCell width={280} sx={{ lineHeight: '1.6!important', whiteSpace: 'pre-wrap', textAlign: 'left!important', p: '30px 30px!important', verticalAlign: 'top' }}>
                          {
                            storeData.addInjectionList[1].map((item: any) => {
                              return (
                                '- ' + replaceCommas(item) + '\n'
                              )
                            })
                          }
                        </TableCell>
                    }
                    {
                      storeData.addInjectionList[2] == null
                        ? <TableCell width={300}></TableCell>
                        : <TableCell width={280} sx={{ lineHeight: '1.6!important', whiteSpace: 'pre-wrap', textAlign: 'left!important', p: '30px 30px!important', verticalAlign: 'top' }}>
                          {
                            storeData.addInjectionList[2].map((item: any) => {
                              return (
                                '- ' + replaceCommas(item) + '\n'
                              )
                            })
                          }
                        </TableCell>
                    }
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          : ''
      }

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tab03})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}


export default ComparisonHospital;